import { AxiosResponse } from "axios";

import { sendRequest } from "../request/axios";
import { AxiosHttpError } from "../types/error.type";

export async function validatePromoCode(code: string, restaurantID: number) {
  try {
    await sendRequest<never, AxiosResponse>(
      "get",
      `/promo-code/validate/?code=${code.replace(
        " ",
        "%20"
      )}&restaurant=${restaurantID}`
    );
    return { success: true };
  } catch (error) {
    console.log(error);
    const axiosError = error as AxiosHttpError;
    return {
      success: false,
      error: axiosError.response?.data,
    };
  }
}
